<template>
  <!-- 服务场景 -->
  <div class="mainBox wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">服务场景</div>
    </div>
    <div class="sceneGrid">
      <div class="sceneItem" v-for="(item, index) in sceneList" :key="index">
        <OssImg class="sceneBgc maria" fit="cover" :src="item.bgc" alt="" />
        <div class="sceneInfo">
          <OssImg class="sceneIcon" :src="item.icon" alt="" />
          <div>{{ item.title }}</div>
          <div v-html="item.subTitle"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- 智能储存柜 -->
  <div class="mainBox storeWrap wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">智能储存柜</div>
      <div class="text2">危化品安全存储与高效管理</div>
    </div>
    <el-tabs
      v-if="products.smartStorage.length"
      v-model="activeName"
      class="storeTabs"
      :stretch="true"
    >
      <el-tab-pane
        :name="index"
        v-for="(item, index) in products.smartStorage"
        :key="index"
      >
        <template #label>
          <div class="storeTabItem column_flex mariaNoShadow">
            <OssImg class="storeTabImg" :src="item.icon" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </template>
      </el-tab-pane>
    </el-tabs>
    <div
      v-if="products.smartStorage.length"
      class="storeInfo"
      @click="handleSmartStorageNav"
    >
      <OssImg
        class="storeTabImg"
        :src="currentSmartStorage.productsHeaderOssUrl"
        alt=""
      />
      <div class="storeText">
        <div>
          {{ currentSmartStorage.productsTitle || currentSmartStorage.title }}
        </div>
        <div v-html="formatSmartStorageRemark(currentSmartStorage.productsRemark)"></div>
        <CommonBtn
          class="maria"
          title="配置方案"
          @click.stop="navTo('/consult')"
          style="max-width: 5rem;"
        >
        </CommonBtn>
      </div>
    </div>
  </div>

  <!-- 智能终端 -->
  <div class="mainBox terminalWrap wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">智能终端</div>
      <div class="text2">危化品安全存储与高效管理</div>
    </div>

    <!-- 标签式导航栏 -->
    <div class="terminalTabs">
      <div
        class="tabItem"
        :class="{ activeTab: activeTerminalIndex === index }"
        v-for="(item, index) in products.labelTerminal"
        :key="item.id"
        @click="handleTerminalClick(index)"
      >
        {{ item.productsTitle }}
      </div>
    </div>

    <!-- 功能模块区 -->
    <div class="terminalContent" v-if="products.labelTerminal?.length">
      <div class="contentLayout">
        <!-- 左侧设备展示区 -->
        <div class="deviceDisplay">
          <div
            class="deviceImage maria"
            @click="
              navTo('/product/detail', {
                id: products.labelTerminal[activeTerminalIndex].id,
              })
            "
          >
            <OssImg
              class="terminalImg"
              :src="
                products.labelTerminal[activeTerminalIndex].productsHeaderOssUrl
              "
              alt=""
            />
          </div>
        </div>

        <!-- 右侧功能网格区 -->
        <div class="featureGrid">
          <div
            class="featureCard maria"
            v-for="(item, index) in products.labelTerminal[activeTerminalIndex]
              .brightSpots"
            :key="index"
            @click="
              navTo('/product/detail', {
                id: products.labelTerminal[activeTerminalIndex].id,
              })
            "
          >
            <div class="featureTitle">
              <img :src="item.icon" alt="" />
              {{ item.brightSpot }}
            </div>
            <div class="featureDesc">{{ item.brightSpotDetail }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 危废暂存柜 -->
  <div class="storeWrap wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">危废暂存柜</div>
      <div class="text2">智能管控零疏漏，危废暂存更安心</div>
    </div>
    <el-carousel height="400px" motion-blur>
      <el-carousel-item v-for="item in products.wasteStorage" :key="item">
        <div
          class="storeContainers"
          @click="navTo('/product/detail', { id: item.id })"
        >
          <OssImg
            class="storeContainersImg"
            :src="item.productsHeaderOssUrl"
            alt=""
          />
          <div
            class="storeIntro"
            v-html="item.productsRemark.replace(/\/n/g, '<br/>')"
          ></div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>

  <!-- 危化品智能管理终端 -->
  <div class="hazardTerminalWrap wow animate__animated animate__fadeIn">
    <div class="mainBox">
      <div class="title" style="text-align: center">
        <div class="text1">危化品智能管理终端</div>
        <div class="text2">{{ hazardTerminalTags.join("　　") }}</div>
      </div>
      <div class="hazardTerminalContent">
        <div class="hazardTerminalImageBox">
          <img
            class="hazardTerminalImage"
            :src="hazardTerminalImage"
            alt="危化品智能管理终端"
          />
        </div>
        <div class="hazardTerminalInfo maria">
          <p
            v-for="(item, index) in hazardTerminalInfo"
            :key="index"
          >
            {{ item }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- 环境传感器 -->
  <div class="transducerBox wow animate__animated animate__fadeIn">
    <el-carousel height="641px" motion-blur>
      <el-carousel-item v-for="item in products.environmentSensor" :key="item">
        <div
          class="transducer mainBox"
          @click="navTo('/product/detail', { id: item.id })"
        >
          <OssImg
            class="transducerImg"
            :src="item.productsHeaderOssUrl"
            alt=""
          />
          <div class="transducerRight">
            <div class="title">
              <div class="text1">环境传感器</div>
              <div class="text2">毫秒响应预警，环境风险无处遁形</div>
            </div>
            <div
              class="transducerText"
              v-html="item.productsRemark.replace(/\/n/g, '<br/>')"
            ></div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>

  <!-- 门禁控制 -->
  <div class="mainBox wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center;margin-top:4rem">
      <div class="text1">门禁控制</div>
      <div class="text2">高效运行，加速科研</div>
    </div>
    <div class="entranceGrid">
      <div
        class="entranceItem"
        v-for="(item, index) in products.accessControl"
        :key="index"
        @click="navTo('/product/detail', { id: item.id })"
      >
        <div class="imgBox maria03">
          <OssImg class="entranceImg" :src="item.productsHeaderOssUrl" alt="" />
        </div>
        <div class="entranceInfo">
          <div>{{ item.productsTitle }}</div>
          <div v-html="item.productsRemark.replace(/\/n/g, '<br/>')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, reactive } from "vue";
import { WOW } from "wowjs";
import ProductApi from "@/api/productApi";
import { navTo } from "@/utils/util";
import CommonBtn from "@/components/commenBtn.vue";

const productApi = new ProductApi();
const products = reactive({
  smartStorage: [], // 智能存储柜
  labelTerminal: [], // 智能终端
  wasteStorage: [], // 危废暂存柜
  environmentSensor: [], // 环境传感器
  labEquipment: [], // 实验仪器设备
  accessControl: [], // 门禁控制
});

onMounted(() => {
  console.log("onMounted------------------");
  const wow = new WOW();
  wow.init();
  getProductList();
});
const sceneList = ref([
  {
    bgc: "images/pdtHard1.png",
    icon: "images/pdjHardIcon1.png",
    title: "高校",
    subTitle: `
      管制类储存<br />
     使用追溯<br />
     多级审批<br />
     数据统计<br />`,
  },
  {
    bgc: "images/pdtHard2.jpg",
    icon: "images/pdjHardIcon2.png",
    title: "科研",
    subTitle: `
      课题组库存共享<br />
     高危管控<br />
     过程自动录像存档<br />
     实验所使用数据关联<br />`,
  },
  {
    bgc: "images/pdtHard3.png",
    icon: "images/pdjHardIcon3.png",
    title: "医疗",
    subTitle: `
      数量严格把控<br />
     多科室药品流转简化<br />
     自动读取药品有效期<br />
     库存补货记<br />`,
  },
  {
    bgc: "images/pdtHard4.png",
    icon: "images/pdjHardIcon4.png",
    title: "生产",
    subTitle: `
      自动计算所需原料用量<br />
     防爆监测<br />
     人员管控<br />
     取用过程与库存监管<br />`,
  },
]);

//智能存储柜
const activeName = ref(0);
const removedSmartStorageTitles = ["抽拉式工具车"];
const smartStorageOrder = [
  {
    icon: "images/pdjHardIcon7.png",
    title: "模块式组合智能柜",
    aliases: ["模块式组合智能柜", "模块式组合柜"],
  },
  {
    icon: "images/pdjHardIcon5.png",
    title: "耐腐耐火智能柜",
    aliases: ["耐腐耐火智能柜"],
  },
  {
    icon: "images/pdjHardIcon6.png",
    title: "防爆存储柜",
    aliases: ["防爆存储柜", "防爆智能柜", "六分区智能柜"],
  },
  {
    icon: "images/pdjHardIcon8.png",
    title: "毒麻药剂柜",
    aliases: ["毒麻药剂柜"],
  },
  {
    icon: "images/pdjHardIcon9.png",
    title: "元器件智能柜",
    aliases: ["元器件智能柜"],
  },
];

const smartStorageDisplayOrder = smartStorageOrder.map((item) => item.title);

const terminalDisplayOrder = [
  "RFID手持终端",
  "抽拉式台秤",
  "折叠翻盖台秤",
  "智能管控中控平台",
];

const removedTerminalTitles = ["自助智能打印终端", "智能打印终端", "打印产品机"];
const scaleTerminalTitles = ["抽拉式台秤", "折叠翻盖台秤"];
const terminalFallbackIcons = ["cpu.png", "battery.png", "code.png", "box.png", "wifi.png", "robot.png"];
const terminalIconMap = {
  RFID手持终端: terminalFallbackIcons,
  智能管控中控平台: ["scan.png", "loc.png", "list.png", "tag.png", "bar.png", "home.png"],
  抽拉式台秤: [
    "lifecycle-management.png",
    "traceability-query.png",
    "linked-control.png",
    "integrated-hardware.png",
    "high-precision.png",
    "system.png",
  ],
  折叠翻盖台秤: [
    "folding-portable.png",
    "lifecycle-management.png",
    "traceability-query.png",
    "linked-control.png",
    "high-precision.png",
    "system.png",
  ],
};
const scaleBrightSpotIconRules = [
  { keywords: ["折叠", "便携"], icon: "folding-portable.png" },
  { keywords: ["全生命周期", "全周期", "生命周期"], icon: "lifecycle-management.png" },
  { keywords: ["追溯", "查询"], icon: "traceability-query.png" },
  { keywords: ["联动", "管控"], icon: "linked-control.png" },
  { keywords: ["高精度", "计量", "称重"], icon: "high-precision.png" },
  { keywords: ["集成", "硬件"], icon: "integrated-hardware.png" },
];

//门禁
const entranceList = ref([
  {
    title: "立地式RFID门禁",
    subTitle: `声光报警<br />
      多标签读取<br />
      在线离线报警模式<br />
      红外触发读取<br />`,
    img: "images/pdtHard7.png",
  },
  {
    title: "班牌式出入门禁",
    subTitle: `智能交互终端<br />
      房间资产清单<br />
      交互式门禁授权与控制<br />
      人脸刷卡出入控制<br />`,
    img: "images/pdtHard8.png",
  },
  {
    title: "吸顶式RFID门禁",
    subTitle: `高效门禁控制<br />
      安装维护简便<br />
      安装维护简便<br />
      精准身份验证<br />`,
    img: "images/pdtHard9.png",
  },
]);

const hazardTerminalImage = require("@/assets/images/UIV5/device.webp");
const hazardTerminalTags = ["批量识别", "快速盘点", "拓展性强"];
const hazardTerminalInfo = [
  "支持Windows(可选配安卓)；配备 21.5 寸工业触控屏",
  "一体化设计，集成人脸识别、超高频/高频RFID读写、高拍仪等，实现标签与物品信息的快速录入绑定，全面管理物品出入库等，数据实时记录，确保物品可追溯，使用有记录。",
  "标配有线网口，可按需选配 WiFi、4G 无线通讯；搭载UHF超高频RFID模块，支持多种标签识别（一维、二维、RFID等），工作频段 840MHz-960MHz，完成试剂标签识别溯源。",
  "标准 AC220V 市电供电，满足实验室长期 7×24 小时稳定运行需求。",
];

//智能终端
const activeTerminalIndex = ref(0);
const currentSmartStorage = computed(() => products.smartStorage[activeName.value] || {});

const handleTerminalClick = (index) => {
  activeTerminalIndex.value = index;
};

const handleSmartStorageNav = () => {
  if (currentSmartStorage.value.id) {
    navTo("/product/detail", { id: currentSmartStorage.value.id });
  }
};

const formatSmartStorageRemark = (remark) => {
  return (remark || "").replace(/\。/g, "。<br /><br />");
};

function getSmartStorageConfig(productTitle) {
  return smartStorageOrder.find((item) => item.aliases.includes(productTitle));
}

function normalizeSmartStorageProduct(product) {
  if (removedSmartStorageTitles.includes(product.productsTitle)) return null;

  const config = getSmartStorageConfig(product.productsTitle);
  if (!config) return null;

  return {
    ...product,
    icon: config.icon,
    title: config.title,
    productsTitle: config.title,
    isExactTitleMatch: product.productsTitle === config.title,
  };
}

function getDisplayOrder(title, order) {
  const index = order.indexOf(title);
  return index === -1 ? order.length : index;
}

function sortByDisplayOrder(list, order, titleKey) {
  return list.sort((a, b) => {
    const sortA = getDisplayOrder(a[titleKey], order);
    const sortB = getDisplayOrder(b[titleKey], order);
    if (sortA !== sortB) return sortA - sortB;
    return 0;
  });
}

function getTerminalBrightSpotIcon(product, brightSpot, index) {
  const iconList = terminalIconMap[product.productsTitle] || terminalFallbackIcons;

  if (scaleTerminalTitles.includes(product.productsTitle)) {
    const matchedRule = scaleBrightSpotIconRules.find((rule) =>
      rule.keywords.some((keyword) => brightSpot?.brightSpot?.includes(keyword)),
    );
    if (matchedRule) return matchedRule.icon;
  }

  return iconList[index % iconList.length];
}

/**
 * 获取产品列表
 */
const getProductList = async () => {
  let res = await productApi.getProductList();
  const smartStorageMap = new Map();
  products.smartStorage = [];
  products.labelTerminal = [];
  products.wasteStorage = [];
  products.environmentSensor = [];
  products.labEquipment = [];
  products.accessControl = [];

  res.data.forEach((product) => {
    switch (product.productsType) {
      case "SmartStorageCabinets":
        {
          const normalizedProduct = normalizeSmartStorageProduct(product);
          if (!normalizedProduct) break;

          const currentProduct = smartStorageMap.get(normalizedProduct.title);
          if (!currentProduct || normalizedProduct.isExactTitleMatch) {
            smartStorageMap.set(normalizedProduct.title, normalizedProduct);
          }
        }
        break;
      case "LabelTerminals":
        if (!removedTerminalTitles.includes(product.productsTitle)) {
          products.labelTerminal.push(product);
        }
        break;
      case "HazardousWasteTemporaryStorageCabinets":
        products.wasteStorage.push(product);
        break;
      case "EnvironmentalSensors":
        products.environmentSensor.push(product);
        break;
      case "LabEquipment":
        products.labEquipment.push(product);
        break;
      case "AccessControl":
        products.accessControl.push(product);
        break;
    }
  });

  products.smartStorage = smartStorageDisplayOrder
    .map((title) => smartStorageMap.get(title))
    .filter(Boolean);
  activeName.value = products.smartStorage.length ? 0 : activeName.value;

  products.labelTerminal = sortByDisplayOrder(
    products.labelTerminal,
    terminalDisplayOrder,
    "productsTitle",
  );

  console.log("products.labelTerminal", products.labelTerminal);
  products.labelTerminal.forEach((product) => {
    product.brightSpots?.forEach((item, i) => {
      const iconName = getTerminalBrightSpotIcon(product, item, i);
      item.icon = require(`@/assets/images/icon/${iconName}`);
    });
  });
};
</script>

<style lang="scss" scoped>
.sceneGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 100%;

  .sceneItem {
    flex: 1;
    height: 100%;
    height: 26.75rem;

    position: relative;
    overflow: hidden;
    background: rgba($color: #000000, $alpha: 0.4);

    &:hover {
      .sceneBgc {
        -webkit-transform: scale3d(1.2, 1.2, 1);
        transform: scale3d(1.2, 1.2, 1);
      }
    }

    .sceneBgc {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      -webkit-transition: -webkit-transform 0.5s;
      transition: transform 0.5s;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
    }

    .sceneIcon {
      width: 5.5rem;
      height: 5.5rem;
      margin-bottom: 1rem;
      position: relative;
    }

    .sceneInfo {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: rgba($color: #000000, $alpha: 0.4);
      position: relative;

      > div:nth-of-type(2) {
        position: relative;
        color: #ffffff;
        font-weight: 600;
        font-size: 1.5rem;
        line-height: 2.125rem;
        margin-bottom: 0.5rem;
      }

      > div:nth-of-type(3) {
        position: relative;
        color: #e7e3e3;
        font-weight: 500;
        font-size: 1rem;
        text-align: center;
        line-height: 2rem;
      }
    }
  }
}

.storeWrap {
  .storeTabs {
    height: 6.75rem !important;

    ::v-deep .el-tabs__header {
      height: 100%;
    }

    ::v-deep .el-tabs__nav {
      height: 6.75rem !important;
      border: none !important;
    }

    ::v-deep .el-tabs__item {
      height: 6.75rem !important;
      border: none !important;
    }

    ::v-deep .el-tabs-bar {
      display: none;
    }

    ::v-deep .el-tabs__nav-wrap::after {
      height: 0 !important;
    }

    ::v-deep .el-tabs__active-bar {
      height: 2px;
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0),
        0%,
        rgba(0, 0, 0, 0) 18%,
        #32a89e 20%,
        #32a89e 80%,
        rgba(0, 0, 0, 0) 81%,
        rgba(0, 0, 0, 0) 100%
      );
      margin: auto;
    }
  }

  .storeTabItem {
    color: #212121;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 2.125rem;

    .storeTabImg {
      width: 3rem;
      height: 3rem;
      margin-bottom: 0.5rem;
    }
  }

  .storeInfo {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    // height: 30.3125rem;

    .storeTabImg {
      flex: 1;
      object-fit: contain;
      width: 39rem;
      height: 30rem;
    }

    .storeText {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      > div:first-of-type {
        color: #212121;
        font-weight: 600;
        font-size: 1.6rem;
        line-height: 2.8125rem;
        margin-bottom: 1rem;
      }

      > div:nth-of-type(2) {
        color: #424242;
        font-weight: 400;
        font-size: 1rem;
      }
    }
  }
}

.storeContainers {
  width: 100%;
  position: relative;

  .storeContainersImg {
    width: 80%;
    height: 400px;
    object-fit: contain;
    top: 0;
    margin-left: 20%;
  }

  .storeIntro {
    padding: 1rem;
    color: #424242;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.375rem;
    line-height: 2.5rem;
    background: #fff;
    border-radius: 1rem;
    position: absolute;
    top: 2rem;
    left: 10%;
    width: 30%;
  }
}

.hazardTerminalWrap {
  margin-top: 4rem;
  padding: 1px 0 4rem;
  background: linear-gradient(180deg, #f7f9fc 0%, #f4f7fb 100%);

  .title {
    margin-top: 3.5rem;

    .text2 {
      margin-bottom: 3rem;
    }
  }

  .hazardTerminalContent {
    display: grid;
    grid-template-columns: minmax(0, 1.15fr) minmax(22rem, 0.85fr);
    align-items: center;
    gap: 4rem;
  }

  .hazardTerminalImageBox {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 26rem;
  }

  .hazardTerminalImage {
    width: 100%;
    max-height: 31rem;
    object-fit: contain;
  }

  .hazardTerminalInfo {
    padding: 1.5rem 2rem;
    background: #ffffff;
    border-radius: 0.5rem;
    box-shadow: 0 0.75rem 2.5rem rgba(24, 55, 88, 0.08);
    box-sizing: border-box;

    p {
      color: #4f4f4f;
      font-size: 1rem;
      font-weight: 500;
      line-height: 1.8rem;
      margin-bottom: 1.25rem;
      word-break: break-word;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.transducerBox {
  width: 100%;
  height: 40.0625rem;
  background: url("@/assets/images/bg/pdtHard6.png");
  background-size: 100% 100%;

  .title {
    margin: 0;
  }

  .title > .text1 {
    font-size: 4rem;
    color: #fff;
    margin-bottom: 1.5rem;
  }

  .title > .text2 {
    font-size: 2rem;
    margin-bottom: 2.1875rem;
    color: #fff;
  }

  .transducer {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .transducerImg {
      width: 30% !important;
      height: 24.375rem;
      margin-right: 5.8125rem;
    }

    .transducerRight {
      flex: 1;
    }

    .transducerText {
      width: 100%;
      font-size: 1.25rem;
      color: #fff;
      line-height: 1.75rem;
      text-align: justify;
      padding: 1rem;
      border-radius: 1rem;
      background: #1a4078;
      box-sizing: border-box;
    }
  }
}

.entranceGrid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-bottom: 3.5rem;

  .entranceItem {
    flex: 1;

    .imgBox {
      height: 25.25rem;
      background: #fff;
      border-radius: 0.5rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 2rem;
      box-sizing: border-box;
    }

    .entranceImg {
      width: 80%;
      height: 100%;
      object-fit: contain;
    }

    .entranceInfo {
      width: 100%;
      padding:2rem 1rem;
      box-sizing: border-box;
      text-align: center;

      > div:first-child {
        color: #212121;
        font-weight: 500;
        font-size: 1.5rem;
        line-height: 2.8125rem;
        margin-bottom: 1rem;
      }

      > div:nth-child(2) {
        color: #888888;
        font-weight: 500;
        font-size: 1.1rem;
        line-height: 2.3rem;
      }
    }
  }
}

.terminalWrap {
  padding: 3rem 0;

  .terminalTabs {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 3rem;
    margin-left: -1rem;

    .tabItem {
      margin: 0 1rem;
      font-size: 1.125rem;
      font-weight: 400;
      color: #3d3d3d;
      cursor: pointer;
      position: relative;
      transition: color 0.3s ease;

      &:hover {
        color: #32a89e;
      }

      &.activeTab {
        color: #000000;
        font-weight: 500;

        &::after {
          content: "";
          position: absolute;
          bottom: -0.5rem;
          left: 0;
          right: 0;
          height: 2px;
          background-color: #32a89e;
        }
      }
    }
  }

  .terminalContent {
    width: 100%;
    height: 28rem;
    margin: 0 auto;
    cursor: pointer;

    .contentLayout {
      display: flex;
      height: 100%;
      gap: 3rem;

      // 左侧设备展示区 (40%)
      .deviceDisplay {
        flex: 0 0 40%;

        .deviceImage {
          background-color: #ffffff;
          border-radius: 0.5rem;
          padding: 2rem;
          height: 100%;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;

          .terminalImg {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }

      // 右侧功能网格区 (60%)
      .featureGrid {
        flex: 1;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 2rem;

        .featureCard {
          background-color: #ffffff;
          padding: 1.5rem;
          box-sizing: border-box;
          transition: all 0.3s ease;
          border-radius: 1rem;

          &:hover {
            transform: translateY(-4px);
          }

          .featureTitle {
            font-size: 1rem;
            font-weight: 500;
            color: #424242;
            margin-bottom: 0.75rem;
            display: flex;
            align-items: center;

            img {
              width: 1rem;
              height: 1rem;
              margin-right: 0.5rem;
            }
          }

          .featureDesc {
            font-size: 0.8rem;
            color: #888888;
            line-height: 1.5;
          }
        }
      }
    }
  }
}

// @media(max-width: 768px) {
//   .sceneGrid {
//     grid-template-columns: repeat(2, 1fr);
//   }

//   .storeInfo {
//     display: block !important;

//     img {
//       width: 100%;
//     }
//   }

//   .applicationWrap {
//     display: block;
//     height: auto;

//     .applicationList {
//       width: 100%;
//     }

//     .info {
//       margin: .5rem 0;
//     }
//   }

//   .storeContainers {
//     .storeIntro {
//       position: relative;
//       width: auto;
//       box-sizing: border-box;
//       top: 0;
//       left: 0;
//       margin: 0 1rem;
//     }
//   }

//   .transducerBox {
//     margin-top: 2rem;
//     background: #141d2a;
//     padding: 2rem 0;

//     .transducer {
//       flex-direction: column;

//       img {
//         margin-right: 0;
//         margin-bottom: 1rem;
//       }
//     }
//   }

//   .entranceGrid {
//     display: block;
//   }
// }
</style>
